import { useState, useEffect } from 'react';

interface UseHoverCardPositionReturn {
  rect: DOMRect;
  positionStyle: React.CSSProperties;
}

export const useHoverCardPosition = (
  eventId: string,
  initialRect: DOMRect,
  colorSet: { backgroundColor: string; borderColor: string },
): UseHoverCardPositionReturn => {
  const [rect, setRect] = useState(initialRect);

  useEffect(() => {
    const updatePosition = () => {
      const cardElement = document.querySelector(`[data-event-id="${eventId}"]`) as HTMLElement;
      if (cardElement) {
        const newRect = cardElement.getBoundingClientRect();
        setRect(newRect);
      }
    };

    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [eventId]);

  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;

  const positionStyle: React.CSSProperties = {
    position: 'fixed',
    top: centerY,
    left: centerX,
    width: rect.width + 30,
    height: rect.height + 10,
    transform: 'translate(-50%, -50%) scale(1.1)',
    transformOrigin: 'center center',
    backgroundColor: colorSet.backgroundColor,
    padding: 6,
    borderLeft: `4px solid ${colorSet.borderColor}`,
    borderRadius: 4,
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
    zIndex: 9999,
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    transition: 'transform 5s ease, box-shadow 5s ease',
  };

  return { rect, positionStyle };
};
